import { SiteStructure } from '.generated/Feature.CW.model';
import { ImageField, LinkField } from '@sitecore-content-sdk/nextjs';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';

export const Logo = ({ logo, logoLink }: { logo?: ImageField; logoLink?: LinkField }) => {
  return (
    <div className={'flex ,items-center ,lg:w-[238px] ,lg:h-[76px] ,w-[162px] ,h-[54px]'}>
      <LinkWrapper field={logoLink?.value}>
        <ImageWrapper field={logo} />
      </LinkWrapper>
    </div>
  );
};

const MinimalHeader = (props: SiteStructure.Header.Header_Component) => {
  const { fields } = props || {};
  const { logo, logoLink } = fields || {};

  return (
    <>
      <div
        className={
          'font-centureyGothic border-none border-black shadow-global-nav bg-white z-20 relative'
        }
        id="header-desktop"
      >
        <div className={'max-w-screen-xxl w-full mx-auto lg:px-20 px-10 py-[18px]'}>
          <div className={'flex items-center'}>
            <Logo logo={logo} logoLink={logoLink} />
          </div>
        </div>
      </div>
    </>
  );
};

export default MinimalHeader;
